export default __webpack_public_path__ + "static/media/img_chart_grade_B.2e34b46969125735321f8c2c5e8bd69c.svg";